import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'I cancel my subscription',
    confirm: 'I take advantage',
    description:
      'Keep your pro account, at half price for the next 6 months.\nAnd always:',
    items: [
      'your physical and virtual Mastercard cards;',
      'your usual additional services: invoicing, scanning of receipts, accounting exports, etc;',
      'access to our partner offers.',
    ],
    title: 'How about keeping your account at half price?',
  },
  fr: {
    cancel: 'Je résilie mon abonnement',
    confirm: 'J’en profite',
    description:
      'Gardez votre compte pro, à moitié prix pendant les 6 prochains mois.\nEt toujours :',
    items: [
      'vos cartes physiques et virtuelles du réseau Mastercard ;',
      'vos services additionnels habituels : facturation, numérisation de reçus, exports comptables... ;',
      'l’accès à nos offres partenaires.',
    ],
    title: 'Et si vous gardiez votre compte à moitié prix ?',
  },
} as const);
